/* ============================================================================
   LAH — TELA DE MOTIVOS AO ESCOLHER "APENAS ARMACAO"
   Tema: Outubro (Pre Green Friday 2.0)

   ============================================================================
   A TRAVA E POR PRODUTO, NAO POR NAVEGADOR
   ============================================================================
   Antes a chave era unica para a loja inteira: quem visse o questionário no
   Lee de manha nao veria em nenhum outro modelo ate o dia seguinte.

   Isso derrubava justamente o caso que queremos pegar — o cliente que roda
   tres ou quatro modelos antes de decidir — e dava a impressao de que
   determinados produtos (Freddie, Anpa, Ton) nao tinham o questionário, sendo
   que eram apenas os ultimos da fila de testes.

   Agora a chave leva o handle do produto: uma vez por dia POR MODELO. O
   cliente indeciso e ouvido em cada um, e ninguem ve a mesma tela duas vezes
   no mesmo produto no mesmo dia.

   PARA TESTAR sem esperar o dia virar: acrescente ?lahteste=1 ao endereco. A
   trava do dia e ignorada enquanto esse parametro estiver na URL.

   ============================================================================
   A ORDEM DO FLUXO
   ============================================================================
   "Sem Grau - apenas armação" tem proximo passo vazio no metaobjeto, entao o
   configurador cai sozinho em Acessorios e depois no Resumo. Interceptando o
   clique aqui, a ordem fica:

     apenas armação -> QUESTIONARIO -> oferta de 30% -> acessorios -> resumo

   Nada disso depende de o produto ter clip-on: quem manda e o nome do item.

   ============================================================================
   SOMENTE EM OCULOS DE GRAU. Em oculos de sol, comprar so a armacao e compra
   normal, e o cupom de lentes de grau nao teria onde ser usado. O tipo chega
   em window.LAH_PRODUTO.tipo, preenchido pelo carregador.

   POR QUE INTERCEPTAR EM VEZ DE EDITAR O CONFIGURADOR: o fluxo de lentes e um
   componente Alpine grande e sensivel. Interceptamos na fase de CAPTURA e
   devolvemos o controle intacto. Removendo este arquivo, tudo volta ao
   original.

   ROTEAMENTO DOS MOTIVOS: "nao tenho receita" e "preciso atualizar" levam a
   mesma resposta, mudando so o titulo. "Consulta marcada" vai para a reserva —
   e o unico motivo em que o cliente ja sabe QUANDO tera a receita.
   ============================================================================ */

(function () {
    'use strict';

    var ITEM_SELECTOR = '.product-lens-select-item';
    var OVERLAY_ID = 'lah-frameonly';
    var STORAGE_BASE = 'lah_frameonly_last_seen';
    var TIPO_VALIDO = 'oculos';

    var REASON_MAP = {
        sem_receita: { step: 'receita', title: 'Você não precisa da receita agora' },
        receita_vencida: { step: 'receita', title: 'Dá tempo de atualizar depois' },
        consulta_marcada: { step: 'reserva', title: null },
        medo_encaixe: { step: 'encaixe', title: null },
        outra_otica: { step: 'outra_otica', title: null }
    };

    function normalize(text) {
        return (text || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim();
    }

    var produto = window.LAH_PRODUTO || {};

    /* Oculos de sol nao entram — "oculos de sol" normalizado nao e igual a
       "oculos", entao a comparacao exata basta. */
    if (normalize(produto.tipo) !== TIPO_VALIDO) return;

    var STORAGE_KEY = STORAGE_BASE + ':' + (produto.handle || 'produto');
    var TESTE = window.location.search.indexOf('lahteste=1') !== -1;

    var overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    var pendingItem = null;
    var allowThrough = false;
    var shownThisFlow = false;

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function today() {
        var d = new Date();
        var m = d.getMonth() + 1;
        var day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }

    function seenToday() {
        if (TESTE) return false;

        try {
            return window.localStorage.getItem(STORAGE_KEY) === today();
        } catch (e) {
            return false; /* sem storage: mostra, que e o comportamento util */
        }
    }

    function markSeenToday() {
        try {
            window.localStorage.setItem(STORAGE_KEY, today());
        } catch (e) { /* segue sem persistir */ }
    }

    function isFrameOnly(el) {
        return normalize(el.getAttribute('data-item-name')).indexOf('apenas armacao') !== -1;
    }

    function showStep(stepName) {
        var steps = overlay.querySelectorAll('[data-lah-fo-step]');
        Array.prototype.forEach.call(steps, function (step) {
            var isReasons = step.getAttribute('data-lah-fo-step') === 'reasons';
            var match = step.getAttribute('data-lah-fo-step') === stepName;

            if (isReasons) {
                step.style.display = match ? 'block' : 'none';
            } else {
                step.classList.toggle('is-active', match);
            }
        });
    }

    function open(item) {
        pendingItem = item;
        overlay.hidden = false;
        overlay.classList.add('is-open');
        showStep('reasons');
        document.body.classList.add('hidden-scroll');

        markSeenToday();
        track('lens_frameonly_prompt', { produto: produto.handle || '' });
    }

    function close() {
        overlay.classList.remove('is-open');
        overlay.hidden = true;
        document.body.classList.remove('hidden-scroll');
    }

    /* Devolve o clique ao configurador. Como "apenas armacao" tem proximo
       passo vazio, o Alpine leva direto para acessorios — e o resumo depois. */
    function proceed() {
        var item = pendingItem;
        allowThrough = true;
        close();

        if (item) {
            item.click();
        }

        allowThrough = false;
        pendingItem = null;
    }

    /* ---- Intercepta ANTES do Alpine (fase de captura) ---- */
    document.addEventListener('click', function (event) {
        if (allowThrough) return;

        var item = event.target.closest ? event.target.closest(ITEM_SELECTOR) : null;
        if (!item) return;
        if (!isFrameOnly(item)) return;
        if (shownThisFlow) return;
        if (seenToday()) return;

        event.preventDefault();
        event.stopPropagation();

        shownThisFlow = true;
        open(item);
    }, true);

    /* ---- Escolha do motivo ---- */
    overlay.addEventListener('click', function (event) {
        var target = event.target;

        var reasonBtn = target.closest('[data-lah-fo-reason]');
        if (reasonBtn) {
            var reason = reasonBtn.getAttribute('data-lah-fo-reason');
            var config = REASON_MAP[reason];
            if (!config) return;

            track('lens_frameonly_reason', { reason: reason });

            if (config.title) {
                var titleEl = overlay.querySelector('[data-lah-fo-answer-title]');
                if (titleEl) titleEl.textContent = config.title;
            }

            showStep(config.step);
            return;
        }

        if (target.closest('[data-lah-fo-choose-lens]')) {
            track('lens_frameonly_recovered', {});
            pendingItem = null;
            close();
            return;
        }

        if (target.closest('[data-lah-fo-continue]')) {
            track('lens_frameonly_continued', {});
            proceed();
            return;
        }

        if (target.closest('[data-lah-fo-back]')) {
            showStep('reasons');
            return;
        }

        if (target.closest('[data-lah-res-salvar]')) {
            return; /* o proprio lah-reserva.js cuida; nao fechamos a tela */
        }

        if (target.closest('[data-lah-fo-close]') || target === overlay) {
            track('lens_frameonly_dismissed', {});
            pendingItem = null;
            close();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
            track('lens_frameonly_dismissed', {});
            pendingItem = null;
            close();
        }
    });

    /* Reabrir o configurador reinicia a trava DE SESSAO, mas nao a do dia. */
    document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest('.openProductLens')) {
            shownThisFlow = false;
        }
    });
})();
